<template>
  <div class='loadtask'>
      <el-form :model="formData"  ref="formData" label-width="110px" size='large' inline>
      <!-- <el-form-item label="带货任务商品id" prop="kolgsid" >
        <el-input v-model="formData.kolgsid"  placeholder clearable class='w-210'></el-input>
      </el-form-item> -->
      <el-form-item label="落地商城" prop="platform" class="p-form-item">
        <el-select v-model="formData.platform" placeholder>
          <el-option
            v-for="(item,index) in platform_list"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺名称" prop="store_name">
        <el-input v-model="formData.store_name" placeholder clearable></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="goods_name">
        <el-input v-model="formData.goods_name" placeholder clearable></el-input>
      </el-form-item>
      

      <!-- <el-form-item label="商单创建人" prop="order_adid">
        <el-select
          v-model="formData.order_adid"
          filterable
          clearable
          remote
          :remote-method="getAnyAdid"
          placeholder="请选择"
        >
          <el-option
            v-for="item in any_options"
            :key="item.adid"
            :label="item.user_name"
            :value="item.adid"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="创建时间" prop="time" class="time-val">
        <el-date-picker
          @change="getCreateTime"
          v-model="formData.time"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="w-210"
          clearable
        ></el-date-picker>
      </el-form-item> -->
      <el-form-item label="达人昵称" prop="nickname">
        <el-select
          v-model="formData.nickname"
          filterable
          clearable
          remote
          :remote-method="getKolList"
          placeholder="请选择"
        >
          <el-option
            v-for="item in kol_options"
            :key="item.klurid"
            :label="item.nickname"
            :value="item.klurid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="达人平台" prop="type">
        <el-select v-model="formData.type" clearable placeholder="请选择">
          <el-option
            v-for="item in platform_options"
            :key="item.klpmid"
            :label="item.platform_name"
            :value="item.klpmid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否需要寄样" prop="is_send_samples">
        <el-select v-model="formData.is_send_samples" clearable placeholder="请选择">
          <el-option
            v-for="item in is_send_samples_list"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推广形式" prop="promote_type">
        <el-select v-model="formData.promote_type" clearable placeholder="请选择">
          <el-option
            v-for="item in promote_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            class='mr-4'
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作状态" prop='check_status'>
       <el-select v-model="formData.check_status" clearable placeholder="请选择">
          <el-option
            v-for="item in tag_list"
            :key="item.status"
            :label="item.name"
            :value="item.status"
            class='mr-4'
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form label-width="110px">
      <el-form-item label>
        <el-button type="primary" @click="seachList" size='medium'>搜索</el-button>
        <el-button @click="clearForm" size='medium'>重置</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-tabs v-model="formData.check_status" type="card" @tab-click="handleClick">
      <el-tab-pane :name="item.status" v-for="(item,index) in tag_list" :key="index">
        <span slot="label">{{item.name}}({{item.num}})</span>
      </el-tab-pane>
    </el-tabs> -->
    <div class='tab-box'>
      <el-button v-for='(item,index) in tag_list' :key='index'  class="page-btn-tab" :class="{ active:item.status===active}"  @click="handleClick(item.status)">
        {{item.name}}({{item.num}})
      </el-button>
    </div>
    <el-table :data="list" :header-cell-style="{background: '#f9f9f9', color: '#333'}">
      <el-table-column label="商品信息" width="90px">
        <template slot-scope="scope">
          <div @click="openUrl(scope.row.kol_goods.goods_link)">
            <img :src="scope.row.kol_goods.goods_img" class="page-goods-img pointer" />
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180px">
        <template slot-scope="scope">
          <div>带货任务商品ID：{{scope.row.kolgsid}}</div>
          <div>商品名称：{{scope.row.kol_goods.goods_name}}</div>
          <div>
            商城：
            <span v-if="scope.row.kol_goods.platform == 'taobao'">【淘宝】</span>
            <span v-if="scope.row.kol_goods.platform == 'tianmao'">【天猫】</span>
            <span v-if="scope.row.kol_goods.platform == 'jingdong'">【京东】</span>
            <span v-if="scope.row.kol_goods.platform == 'suning'">【苏宁】</span>
            <span v-if="scope.row.kol_goods.platform == 'kaola'">【考拉】</span>
            <span v-if="scope.row.kol_goods.platform == 'douyin'">【抖音小店】</span>
            <span v-if="scope.row.kol_goods.platform == 'weipinhui'">【唯品会】</span>
            <span v-if="scope.row.kol_goods.platform == 'wangyiyanxuan'">【网易严选】</span>
          </div>
          <div v-if="scope.row.kol_goods">店铺：{{scope.row.kol_goods.store_name}}</div>
          <div>是否包邮：{{scope.row.is_postage==1?'包邮':'不包邮'}}</div>
          <div v-if="scope.row.kol_goods">可供样品数：{{scope.row.kol_goods.sample_number}}</div>
          <div v-if="scope.row.kol_goods">日常售价：¥{{scope.row.kol_goods.daily_price}}</div>
          <div v-if="scope.row.kol_goods">达人专属价：¥{{scope.row.kol_goods.kol_special_price}}</div>
          <!-- <div v-if="scope.row.kol_goods">预期佣比：{{Number(scope.row.kol_goods.commission_rate)}}%</div> -->
        </template>
      </el-table-column>
      <el-table-column label="达人信息">
          <template slot-scope='scope'>
              <div v-if="scope.row.kol_user">昵称：{{scope.row.kol_user.nickname}}</div>
              <div v-if="scope.row.kol_user">平台：{{scope.row.kol_user.type_name}}</div>
              <!-- <div v-if="scope.row.kol_user">达人号：{{scope.row.kol_user.id}}</div> -->
              <div v-if="scope.row.kol_user">粉丝数：{{Number(scope.row.kol_user.fans)}}</div>
              <!-- <el-button type="text" @click="getCooperation(scope.row)">查看执行合作形式及报价</el-button> -->
              <div>推广形式： 
                 <span class="daren-tag" v-if="scope.row.promote_video==2">短视频</span>
                 <span class="daren-tag" v-if="scope.row.promote_live==2">直播混播</span>
                 <span class="daren-tag" v-if="scope.row.promote_live_special==2">直播专场</span>
                 <span class="daren-tag" v-if="scope.row.promote_other==2">其他(图文等)</span>
              </div>
              <div>是否需要样品：{{scope.row.is_send_samples==2?'否':'是'}}</div>
              <!-- <div v-if="scope.row.kol_adid_name">媒介对接人：{{scope.row.kol_adid_name}}</div> -->
              <!-- <div v-if="scope.row.operator_adid_name">运营负责人：{{scope.row.operator_adid_name}}</div> -->
              <div>档期：</div>
              <!-- <div class='page-pointer' @click="goMideaQuestion(scope.row)">达人采访记录</div> -->
              <div class='page-pointer' v-if="scope.row.kol_user.type_name=='抖音'||scope.row.kol_user.type_name=='快手'" @click="goFans(scope.row)">粉丝画像</div>
              <!-- <div></div>
              <el-button type="text" size='large' class='btn-w' @click="goMideaQuestion(scope.row)">达人采访记录</el-button>
              <el-button type='text' size='large' class='btn-w'  v-if="scope.row.kol_user.type_name=='抖音'||scope.row.kol_user.type_name=='快手'" @click="goFans(scope.row)">粉丝画像</el-button>         -->
          </template>
      </el-table-column>
      <el-table-column label="商单信息">
          <template slot-scope='scope'>
              <!-- <div v-if="scope.row.cpx_order">商单评级：{{scope.row.cpx_order.cpx_level}}</div> -->
              <div v-if="scope.row.cpx_order">商单标题：{{scope.row.cpx_order.cpx_order_name}}</div>
              <div v-if="scope.row.cpx_order">
                状态：
                <span class="p-color-succ" v-if="scope.row.cpx_order.check_status=1">进行中</span>
                <span class="p-color-danger" v-if="scope.row.cpx_order.check_status==2">项目失败</span>
                <el-tooltip placement="top" v-if="scope.row.cpx_order.check_status==2">
                    <div slot="content" class="w-500">{{scope.row.cpx_order.check_status_reason}}</div>
                    <span class="p-circle">!</span>
                </el-tooltip>
                <span class="p-color-succ" v-if="scope.row.cpx_order.check_status==3">项目完成</span>
                <span
                    :class="[scope.row.cpx_order.sign_up_time_status=='报名中'?'p-color-succ':'',scope.row.cpx_order.sign_up_time_status=='已截止'?'p-color-danger':'']"
                    v-if="scope.row.cpx_order.sign_up_time_status=='报名中'"
                >·{{scope.row.cpx_order.sign_up_time_status}}</span>
              </div>
              <!-- <div>
                合作模式：
                <span class="sd-tag" v-if="scope.row.cpx_order.cps==2">CPS</span>
                <span class="sd-tag" v-if="scope.row.cpx_order.cpt_recommended==2">CPT种草</span>
                <span class="sd-tag" v-if="scope.row.cpx_order.cpt_goods==2">CPT带货</span>
                <span class="sd-tag" size="mini" v-if="scope.row.cpx_order.cpa==2">CPA</span>
                <span class="sd-tag" v-if="scope.row.cpx_order.cpc==2">CPC</span>
                </div>
                <div>
                推广形式：
                <span class="sd-tag" v-if="scope.row.cpx_order.promote_video==2">短视频</span>
                <span class="sd-tag" v-if="scope.row.cpx_order.promote_live==2">直播混播</span>
                <span class="sd-tag" v-if="scope.row.cpx_order.promote_live_special==2">直播专场</span>
                <span class="sd-tag" v-if="scope.row.cpx_order.promote_other==2">其他(图文等)</span>
                <div v-if="scope.row.cpx_order">预估账期：{{scope.row.cpx_order.expect_payment}}</div>
                <div
                v-if="scope.row.cpx_order"
                >结算方式：{{scope.row.cpx_order.settlement_source==1?'CPX联盟':'非联盟'}}</div>
                <div v-if="scope.row.cpx_order">商单创建人：{{scope.row.cpx_order.order_adid_name}}</div>
                <div v-if="scope.row.cpx_order">项目负责人：{{scope.row.cpx_order.cpx_project_adid_name}}</div>
                <div v-if="scope.row.cpx_order">项目运营负责人：{{scope.row.cpx_order.order_project_adid_name}}</div>
                <div v-if="scope.row.cpx_order">项目媒介负责人：{{scope.row.cpx_order.cpx_project_kol_adid_name}}</div>
                <div v-if="scope.row.cpx_order">项目其他干系人：
                <div
                    v-for="(item,index) in scope.row.cpx_order.cpx_order_other"
                    :key="index"
                >{{item.project_adid_name}} ({{item.project_name}})</div>
                </div>
              </div> -->
          </template>
      </el-table-column>
      <el-table-column label="时间">
          <template slot-scope='scope'>
            <div>
             带货任务状态：
              <span class="p-color-succ" v-if="scope.row.check_status==1">合作成功</span>
              <span class="p-color-danger" v-if="scope.row.check_status==2">合作失败</span>
              <span class="p-color-succ" v-if="scope.row.check_status==3">待审核</span>
              <span class="p-color-succ" v-if="scope.row.check_status==4">待发货</span>
              <span class="p-color-succ" v-if="scope.row.check_status==5">待收货</span>
              <span class="p-color-succ" v-if="scope.row.check_status==6">待交付</span>
              <span class="p-color-succ" v-if="scope.row.check_status==7">交付待确认</span>
              <span class="p-color-danger" v-if="scope.row.check_status==8">已拒绝</span>
              <span class="p-color-danger" v-if="scope.row.check_status==10">已取消</span>
              <span class="p-color-succ" v-if="scope.row.check_status==11">待填写寄样信息</span>
              <span class="p-color-succ" v-if="scope.row.check_status==12">待效果回传</span>
              <span class="p-color-succ" v-if="scope.row.check_complete ==1">· 达标</span>
              <span class="p-color-danger" v-if="scope.row.check_complete ==2">
                <el-tooltip placement="top">
                  <div slot="content" class="w-500">{{scope.row.refuse_reason}}</div>
                  <span>
                    不达标
                    <i class="el-icon-question"></i>
                  </span>
                </el-tooltip>
              </span>
            </div>
            <!-- <div>带货任务创建人：{{scope.row.kol_deal_adid_name}}</div> -->
            <div>创建时间：<div v-if='scope.row.create_time'>{{scope.row.create_time.slice(0,10)}}</div></div>
            <div>达人档期：<div v-if='scope.row.cpx_deal&&scope.row.cpx_deal.kol_time_begin'><div>{{scope.row.cpx_deal.kol_time_begin.slice(0,10)}}-</div>{{scope.row.cpx_deal.kol_time_end.slice(0,10)}}</div></div>
            <div>商单预计推广时间：<div v-if='scope.row.cpx_order&&scope.row.cpx_order.expect_begin_time'><div>{{scope.row.cpx_order.expect_begin_time.slice(0,10)}}-</div>{{scope.row.cpx_order.expect_end_time.slice(0,10)}}</div></div>
            <div v-if="scope.row.kol_goods.platform == 'douyin'">商品实际推广时间：</div>
            <div v-else>商品实际团长时间：</div>
            <div v-if='scope.row.kol_goods&&scope.row.kol_goods.reality_begin_time'><div>{{scope.row.kol_goods.reality_begin_time.slice(0,10)}}-</div>{{scope.row.kol_goods.reality_end_time.slice(0,10)}}</div>
          </template>
      </el-table-column>
      <el-table-column label="操作">
          <template slot-scope='scope'>
            <el-button type='text' size='large'  @click="goDetail(scope.row.kldlid)">查看详情</el-button>
          </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>

    <mediaQuestions v-if='media_questions_obj.media_questions_flag' :media_questions_obj='media_questions_obj'></mediaQuestions>
    <!-- 粉丝画像 -->
    <portraitfans v-if="isfans" :fansObj="fansObj" @closeMask ='isfans = false'></portraitfans>
  </div>
</template>

<script>
import pagePagination from "@/components/page_pagination.vue"
import mediaQuestions from '@/components/cpx/media_questions.vue'
import portraitfans from "@/views/my/portrait_fans.vue"
import utils from "@/utils/util.js";
export default {
  name: "loadtask",
  components: {
    pagePagination,
    mediaQuestions:mediaQuestions,
    portraitfans
  },
  data() {
    return {
      isfans: false,
      fansObj: {},
      create: "",
      api:{
          getKaDealList:'/home/getKaDealList',
          getKolPlatformList:'/home/getKolPlatformList',
          getAdidList:'/home/getAdidList',
          getKolUserList:'/home/getKolUserList'
      },
      formData: {
        // kolgsid:'',
        goods_name: "",
        store_name: "",
        platform: "",
        nickname: "",
        type: "",
        is_send_samples: "",
        promote_type: "",
        check_status:'',
      },
      pageData: {
        count: 0,
        page: 1,
        offset: 5
      },
      platform_list: [
        { label: "淘宝", value: "taobao" },
        { label: "京东", value: "jingdong" },
        { label: "天猫", value: "tianmao" },
        { label: "苏宁", value: "suning" },
        { label: "考拉", value: "kaola" },
        { label: "抖音小店", value: "douyin" },
        { label: "唯品会", value: "weipinhui" },
        { label: "网易严选", value: "wangyiyanxuan" }
      ],
      kol_options: [], //达人昵称
      platform_options: [], //平台
      any_options: [],
      is_send_samples_list: [
        {
          label: "不需要",
          value: 2
        },
        {
          label: "需要",
          value: 1
        }
      ],
      yunying_options: [],
      adid_options: [],
      promote_options: [
        //推广形式
        { label: "短视频", value: "1" },
        { label: "直播混播", value: "2" },
        { label: "直播专场", value: "4" },
        { label: "其他(图文等)", value: "3" }
      ],
      tag_list: [
        {
          name: "全部",
          num: 0,
          status: ""
        },
        {
          name: "待填写寄样信息",
          num: 0,
          status: "11"
        },
        {
          name: "待发货",
          num: 0,
          status: "4"
        },
        {
          name: "待收货",
          num: 0,
          status: "5"
        },
        {
          name: "待交付",
          num: 0,
          status: "6"
        },
        {
          name: "待效果回传",
          num: 0,
          status: "12"
        },
        {
          name: "合作成功",
          num: 0,
          status: "1"
        },
        {
          name: "合作失败",
          num: 0,
          status: "2"
        },
      ],
      active:'',
      list: [],
      media_questions_obj: {
        media_questions_flag: false,
        klurid: ""
      }
    };
  },
  created() {
    this.formData.platform = this.$route.query.platform;
    this.getKolPlatformList();
    this.getKaDealList();
  },
  methods: {
    seachList(){
     this.pageData.page=1;
     this.active=this.formData.check_status;
    //  this.active=-1;
     this.getKaDealList()
    },
    //列表
    getKaDealList(){
        let _this=this;
        let params=Object.assign(_this.formData);
        params.page = this.pageData.page;
        params.page_size = this.pageData.offset;
        this.$http({
            method:"POST",
            url:_this.api.getKaDealList,
            data:params
        }).then(res=>{
            if(res.code==1){
                _this.list=res.data.data;
                _this.pageData.count=res.data.total;
                let data=res.data;
                _this.tag_list.forEach((item,index)=>{
                    if(item.status==''){
                        item.num=Number(data.unSampleInfoCount)+Number(data.unDeliverCount)+Number(data.unSampleDdlCount)+Number(data.unVideoTypeCount)+Number(data.unScriptDdlCount)+Number(data.unSampleCount)+Number(data.unScriptCount)
                    }else if(item.status==11){
                        item.num=data.unSampleInfoCount
                    }else if(item.status==4){
                        item.num=data.unDeliverCount
                    }else if(item.status==5){
                        item.num=data.unSampleDdlCount
                    }else if(item.status==6){
                        item.num=data.unVideoTypeCount
                    }else if(item.status==12){
                        item.num=data.unScriptDdlCount
                    }else if(item.status==1){
                        item.num=data.unSampleCount
                    }else if(item.status==2){
                        item.num=data.unScriptCount
                    }
                })
            }else{
                console.log(res.msg)
            }
        })
    },
    //达人昵称
    getKolList(name) {
      let _this = this;
        _this
          .$http({
            method: "GET",
            url:_this.api.getKolUserList,
            params: { nickname: name },
            hideloading: true
          })
          .then(res => {
            if (res.code == 1) {
              _this.kol_options = res.data;
            } else {
              _this.$message.error(res.msg);
            }
          })
          .catch(err => {
            console.log(err);
          });
    },
    // 达人平台列表
    getKolPlatformList() {
        let _this=this;
        this.$http({
          method: "GET",
          url: _this.api.getKolPlatformList,
          params: {}
        }).then(res => {
          if (res.code == 1) {
            this.platform_options = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 商单人列表
    getAnyAdid(name) {
      let _this = this;
        _this
          .$http({
            method: "GET",
            url: _this.api.getAdidList,
            params: { name: name },
            hideloading: true
          })
          .then(res => {
            if (res.code == 1) {
              _this.any_options = res.data;
            } else {
              _this.$message.error(res.msg);
            }
          })
          .catch(err => {
            console.log(err);
          });
    },
    clearForm() {
      this.$refs["formData"].resetFields();
    },
    handleClick(status) {
     this.clearForm();
     this.active=status;
     this.formData.check_status=status;
     console.log(status)
     
     this.pageData.page=1;
     this.getKaDealList()
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getKaDealList();
    },
    goDetail(data){
        this.$router.push({
            name:'loaddetail',
            query:{
                kldlid:data
            }
        })
    },
    // 粉丝画像
    goFans(row) {
      this.isfans = true;
      let data={...row};
      data.type=data.kol_user.type;
      this.fansObj = data;
      this.fansObj.luopan_id = data.kol_user.luopan_id;
    },
       // 媒介10问
    goMideaQuestion(data){
        this.media_questions_obj.klurid=data.klurid;
        this.media_questions_obj.media_questions_flag=true;
    },
    openUrl(url) {
      window.open(url);
    },
  }
};
</script>

<style scoped>
.goods-img {
  display: block;
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.w-500{
    width:500px;
}
.w-210{
  width:210px;
}
.p-circle:hover{cursor:pointer;}
.mr-4{
    margin-right:4px;
}
.tab-box{
  border-top:1px solid #f4f4f4;
  display: flex;
  padding:20px 0 10px;
}
.pointer{
  cursor: pointer;
}
</style>
